import { logout } from "appState/auth/authSlice";
import axios from "axios";
import { toast } from "react-toastify";

let store;

export const injectStore = (_store) => {
  store = _store;
};

const API = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

API.interceptors.request.use((req) => {
  const {
    auth: { token },
  } = store.getState();
  if (!token) {
    return req;
  } else {
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  }
});

// const reFreshToken = ({ refreshToken }) => {
//   return axios({
//     method: "POST",
//     url: "",
//     headers: { Authorization: `Bearer ${refreshToken}` },
//   });
// };

API.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error) {
      toast.error(error?.response?.data?.message);
      const {
        auth: { token },
      } = store.getState();
      if (error?.response?.status === 401 && token) {
        store.dispatch(logout());
      }
    }
  }
);

export default API;
